var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6e053e89757ab9bff118dbc30441aa55d015e979"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["dapp_run_multi_chain@delta-labs"]={id:"6e053e89757ab9bff118dbc30441aa55d015e979"};
      